<template>
  <div class="fccGestaoArquivosRepositorio">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Listar" />
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :status="status"
            :actions="actions"
            addFilter
            :items="listagemGestaoArquivoRepositorio"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Novo Repositório"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarGestaoArquivoRepositorio" autocomplete="off">
        <div class="my-2">
          <div class="row">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.repocodigo"
                >Código</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.repodescricao"
                >Descrição</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criar.repoinformacoesgerais"
                >Informações</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="criar.repoativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fcc-button type="submit">{{ labelsSystem.salvar }}</fcc-button>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editGestaoRepositorioModal"
      titleModal="Editar Repositório"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editarGestaoArquivoRepositorio" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.repocodigo"
                >Código</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.repodescricao"
                >Descrição</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" required v-model="editar.repoinformacoesgerais"
                >Informações</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="editar.repoativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      name: 'fccGestaoArquivosRepositorio',
      sortBy: 'ordem',
      titlePage: 'Gestão Arquivos - Repositórios - Listar ',
      titlePDF: 'Lista de Gestão Arquivos - Repositórios',
      itemPorPage: '100',
      baseUrlSga: '',
      listagemGestaoArquivoRepositorio: [],
      editar: {
        repoid: '',
        repocodigo: '',
        repodescricao: '',
        repoinformacoesgerais: '',
        repoativo: ''
      },
      criar: {
        repoid: '',
        repocodigo: '',
        repodescricao: '',
        repoinformacoesgerais: '',
        repoativo: false
      },
      fields: [
        { key: 'repocodigo', label: 'Código', sortable: true, active: true },
        { key: 'repodescricao', label: 'Descrição', sortable: true, active: true },
        { key: 'status', label: 'Status', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      status: [
        {
          funcaoButton: 'changeStatusRepositorio',
          tooltip: 'Alterar Status',
          campoStatus: 'repoativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editGestaoRepositorio',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteGestaoRepositorio',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listandoGestaoArquivosRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSga + 'Repositorio/ListaTodosRepositorio',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemGestaoArquivoRepositorio = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    changeStatusRepositorio: function (action, item) {
      this.repositorio = item.repoid
      this.editar = item
      this.editarGestaoArquivoRepositorio()
    },
    editGestaoRepositorio: function (action, item) {
      this.editar = item
      this.$root.$emit('bv::show::modal', 'editGestaoRepositorioModal')
    },
    deleteGestaoRepositorio: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.repodescricao).then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlSga + 'Repositorio/ExcluirRepositorio?idRepo=' + item.repoid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoGestaoArquivosRepositorio()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarGestaoArquivoRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      this.criar.repoid = 0
      axios
        .post(
          this.baseUrlSga + 'Repositorio/InserirRepositorio',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivosRepositorio()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarGestaoArquivoRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSga + 'Repositorio/AlterarRepositorio',
          this.editar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivosRepositorio()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'editGestaoRepositorioModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'editGestaoRepositorioModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlSga = store.state.baseUrlSga
    this.listandoGestaoArquivosRepositorio()
  }
}
</script>
